import type { Middleware } from "openapi-fetch";

export const WORKSPACE_HEADER_NAME = "X-SG-Workspace-Id";

interface WorkspaceHeaderMiddlewareOptions {
    workspaceId?: string;
}

export function setWorkspaceHeaderMiddleware({ workspaceId }: WorkspaceHeaderMiddlewareOptions): Middleware {
    return {
        onRequest({ request }) {
            if (workspaceId && !request.headers.has(WORKSPACE_HEADER_NAME)) {
                request.headers.set(WORKSPACE_HEADER_NAME, workspaceId);
            }

            return request;
        }
    };
}
